import { tns } from 'tiny-slider/src/tiny-slider';

class LogosSlider {
    constructor(el) {
        this.el = el;
        const logosSlider = tns({
            container: this.el,
            items: 1,
            row:2,
            responsive: {
                641: {
                    items: 3,
                    gutter: 40,
                },
                1025: {
                    items: 6,
                    gutter: 40,

                }

            },
            autoplay: false,
            autoplayButtonOutput: false,
            mouseDrag: true,
            preventScrollOnTouch: 'auto',
            swipeAngle: false,
            speed: 400,
            controls: false,
            gutter: 10,
            nav:true,
            navPosition: "bottom",
            loop: false,
        });
        return logosSlider;
    }
}

export default LogosSlider;